export default __webpack_public_path__ + "d3bd2c68db354f6c0823be0392e3fd2f.jpg";